import { combineReducers } from 'redux';
import { reducerGame } from './reducerGame';

export const rootReducer = combineReducers({
    reducerGame
});